<template>
    <transition>
        <slot :animate="shakeStyle"></slot>
    </transition>
</template>

<script>
// import util from '@/common/util';
export default {
    name: 'shake-animate',
    props: {
        container_class: {
            type: String,
            default: 'shake-wrap'
        },
        type: {
            type: String,
            default: 'shakeX'
        },
        repeat: {
            type: [String, Number],
            default: 2
        },
        delay: {
            type: [String, Number],
            default: 1
        },
        speed: {
            type: String,
            default: 'fast'
        }
    },
    data: function() {
        return {
            shakeStyle: ''
        };
    },
    mounted() {
        let _this = this;
        // util.debounce(function () {
        //     _this.initAnimate();
        // }, 2000)();
    },
    methods: {
        initAnimate() {
            let { repeat, delay, speed, type, container_class } = this;
            this.shakeStyle = `
                animate__animated
                animate__${type}
                animate__repeat-${repeat} 
                animate__delay-${delay}s 
                animate__${speed}
                ${container_class}
            `;
        }
    }
};
</script>

<style lang="scss">
.shake-wrap {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1;

    display: inline-block;
    .animate__animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-duration: var(--animate-duration);
        animation-duration: var(--animate-duration);
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }
    .animate__animated.animate__infinite {
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
    }
    .animate__animated.animate__repeat-1 {
        -webkit-animation-iteration-count: 1;
        animation-iteration-count: 1;
        -webkit-animation-iteration-count: var(--animate-repeat);
        animation-iteration-count: var(--animate-repeat);
    }
    .animate__animated.animate__repeat-2 {
        -webkit-animation-iteration-count: calc(1 * 2);
        animation-iteration-count: calc(1 * 2);
        -webkit-animation-iteration-count: calc(var(--animate-repeat) * 2);
        animation-iteration-count: calc(var(--animate-repeat) * 2);
    }
    .animate__animated.animate__repeat-3 {
        -webkit-animation-iteration-count: calc(1 * 3);
        animation-iteration-count: calc(1 * 3);
        -webkit-animation-iteration-count: calc(var(--animate-repeat) * 3);
        animation-iteration-count: calc(var(--animate-repeat) * 3);
    }
    .animate__animated.animate__delay-1s {
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
        -webkit-animation-delay: var(--animate-delay);
        animation-delay: var(--animate-delay);
    }
    .animate__animated.animate__delay-2s {
        -webkit-animation-delay: calc(1s * 2);
        animation-delay: calc(1s * 2);
        -webkit-animation-delay: calc(var(--animate-delay) * 2);
        animation-delay: calc(var(--animate-delay) * 2);
    }
    .animate__animated.animate__delay-3s {
        -webkit-animation-delay: calc(1s * 3);
        animation-delay: calc(1s * 3);
        -webkit-animation-delay: calc(var(--animate-delay) * 3);
        animation-delay: calc(var(--animate-delay) * 3);
    }
    .animate__animated.animate__delay-4s {
        -webkit-animation-delay: calc(1s * 4);
        animation-delay: calc(1s * 4);
        -webkit-animation-delay: calc(var(--animate-delay) * 4);
        animation-delay: calc(var(--animate-delay) * 4);
    }
    .animate__animated.animate__delay-5s {
        -webkit-animation-delay: calc(1s * 5);
        animation-delay: calc(1s * 5);
        -webkit-animation-delay: calc(var(--animate-delay) * 5);
        animation-delay: calc(var(--animate-delay) * 5);
    }
    .animate__animated.animate__faster {
        -webkit-animation-duration: calc(1s / 2);
        animation-duration: calc(1s / 2);
        -webkit-animation-duration: calc(var(--animate-duration) / 2);
        animation-duration: calc(var(--animate-duration) / 2);
    }
    .animate__animated.animate__fast {
        -webkit-animation-duration: calc(1s * 0.8);
        animation-duration: calc(1s * 0.8);
        -webkit-animation-duration: calc(var(--animate-duration) * 0.8);
        animation-duration: calc(var(--animate-duration) * 0.8);
    }
    .animate__animated.animate__slow {
        -webkit-animation-duration: calc(1s * 2);
        animation-duration: calc(1s * 2);
        -webkit-animation-duration: calc(var(--animate-duration) * 2);
        animation-duration: calc(var(--animate-duration) * 2);
    }
    .animate__animated.animate__slower {
        -webkit-animation-duration: calc(1s * 3);
        animation-duration: calc(1s * 3);
        -webkit-animation-duration: calc(var(--animate-duration) * 3);
        animation-duration: calc(var(--animate-duration) * 3);
    }
    @media print, (prefers-reduced-motion: reduce) {
        .animate__animated {
            -webkit-animation-duration: 1ms !important;
            animation-duration: 1ms !important;
            -webkit-transition-duration: 1ms !important;
            transition-duration: 1ms !important;
            -webkit-animation-iteration-count: 1 !important;
            animation-iteration-count: 1 !important;
        }

        .animate__animated[class*='Out'] {
            opacity: 0;
        }
    }

    .animate__shakeY {
        -webkit-animation-name: shakeY;
        animation-name: shakeY;
    }

    @-webkit-keyframes shakeY {
        from,
        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        10%,
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: translate3d(0, -10px, 0);
            transform: translate3d(0, -10px, 0);
        }

        20%,
        40%,
        60%,
        80% {
            -webkit-transform: translate3d(0, 10px, 0);
            transform: translate3d(0, 10px, 0);
        }
    }
    @keyframes shakeY {
        from,
        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        10%,
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: translate3d(0, -10px, 0);
            transform: translate3d(0, -10px, 0);
        }

        20%,
        40%,
        60%,
        80% {
            -webkit-transform: translate3d(0, 10px, 0);
            transform: translate3d(0, 10px, 0);
        }
    }

    .animate__shakeX {
        -webkit-animation-name: shakeX;
        animation-name: shakeX;
    }

    @-webkit-keyframes shakeX {
        from,
        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        10%,
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: translate3d(-3px, 0, 0);
            transform: translate3d(-3px, 0, 0);
        }

        20%,
        40%,
        60%,
        80% {
            -webkit-transform: translate3d(3px, 0, 0);
            transform: translate3d(3px, 0, 0);
        }
    }
    @keyframes shakeX {
        from,
        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        10%,
        30%,
        50%,
        70%,
        90% {
            -webkit-transform: translate3d(-3px, 0, 0);
            transform: translate3d(-3px, 0, 0);
        }

        20%,
        40%,
        60%,
        80% {
            -webkit-transform: translate3d(3px, 0, 0);
            transform: translate3d(3px, 0, 0);
        }
    }
}
</style>
